import { FC } from 'react'
import WoosmapMultisearch from '../../core/data/woosmap/MultisearchTypes'
import { MapMarkerIcon } from '../icons'
import RecycleIcon from '../icons/RecylceIcon'

interface SuggestionIconProps {
  api: WoosmapMultisearch.API
  stroke?: string
}

const SuggestionIcon: FC<SuggestionIconProps> = (props) => {
  const { api, stroke } = props
  if (api === 'store') {
    return <RecycleIcon stroke={stroke} width={17} height={17} />
  }
  return <MapMarkerIcon />
}

export default SuggestionIcon
